import Breadcrumb from '../../layout/breadcrumb';
import React, { useState, useEffect, Fragment, useCallback, useRef } from 'react';
import Rating from 'react-rating';
import { Container, Row, Col, Card, CardBody, CardHeader, Button, Tooltip } from 'reactstrap';
import shallow from 'zustand/shallow';
import { useGlobalState } from 'state-pool';
import SweetAlert from 'sweetalert2';
import ReactPaginate from 'react-paginate';

import Moment from 'react-moment';

import { worker_firstName, worker_lastName } from '../../constant/names';

import { ASSETS_CDN } from '../../constant/config';
import { useStore } from '../../store/main.store';

import { Loading } from '../Loading';
import { Information } from '../utils/Information';
import { Filter } from '../Filter';

import CONTRACT_LIST from '../../contracts/contractList';
const MARKETPLACE_CONTRACT = CONTRACT_LIST['MARKETPLACE_CONTRACT'];

const MarketplaceSpaceships = () => {
  const [web3, setWeb3] = useGlobalState('Web3');
  const [videoAnimation] = useGlobalState('animateVideo');
  const [userAddress, setUserAddress] = useGlobalState('userAddress');
  const [workerContract] = useGlobalState('workerContract');
  const [marketplaceContract, setMarketplaceContract] = useGlobalState('marketplaceContract');
  const [cryptominesContract, setCryptominesContract] = useGlobalState('cryptominesContract');
  const [stoneContract, setStoneContract] = useGlobalState('stoneContract');

  const [workerAmount, setWorkerAmount] = useGlobalState('workerAmount');
  const [stoneAmount, setStoneAmount] = useGlobalState('stoneAmount');
  const [minePower, setMinePower] = useGlobalState('MinePower');

  // Local state
  const [layoutColumns, setLayoutColumns] = useState(3);
  const [pageNumber, setPageNumber] = useState(0);
  const [loading, setLoading] = useState(true);
  const [filtering, setFiltering] = useState(false);
  // const [display, setDisplay] = useState([]);

  const ARRAY_TO_FILTER = useRef();
  // Pagination:

  const { marketWorkers, displayDataWorkers, updateMarketWorkers, updateDisplayDataWorkers } = useStore(
    (state) => ({
      marketWorkers: state.marketWorkers,
      updateMarketWorkers: state.updateMarketWorkers,
      displayDataWorkers: state.displayDataWorkers,
      updateDisplayDataWorkers: state.updateDisplayDataWorkers,
    }),
    shallow
  );

  const cardsPerPage = 8;
  const pageCount = Math.ceil(marketWorkers?.length / cardsPerPage);

  // const marketplaceArray = require('../../marketItems.json');
  // updateMarketWorkers(marketplaceArray);
  const getMetadata = async (sp) => {
    const worker = Object.assign({ id: sp.tokenId }, sp);
    const currentTime = Date.now();
    worker['contractDueDate'] = parseInt(worker.nftData['contractDueDate']) * 1000;
    worker['contractDate'] = new Date(worker['contractDueDate']);

    if (parseInt(sp.tokenId) > 150000) {
      worker['season'] = 'workers_s2';
    } else {
      worker['season'] = 'workers';
    }

    let min_range = 0;
    let max_range = 255;
    switch (parseInt(worker.nftData['level'])) {
      case 1:
        min_range = 5;
        max_range = 50;
        break;
      case 2:
        min_range = 50;
        max_range = 100;
        break;
      case 3:
        min_range = 100;
        max_range = 150;
        break;
      case 4:
        min_range = 150;
        max_range = 200;
        break;
      case 5:
        min_range = 200;
        max_range = 255;
        break;
    }

    let variantResult = (parseInt(worker.nftData['minePower']) - min_range) / (max_range - min_range);
    //console.log(variantResult)
    if (variantResult >= 0 && variantResult <= 0.6) {
      worker['variant'] = 1;
    } else if (variantResult >= 0.61 && variantResult <= 0.94) {
      worker['variant'] = 2;
    } else {
      worker['variant'] = 3;
    }

    //console.log(currentTime)
    //console.log(worker.contractDueDate)
    //console.log("-----------------")

    if (currentTime >= worker['contractDueDate']) {
      worker['needContract'] = true;
    } else {
      worker['needContract'] = false;
    }

    worker['uid'] = worker['id'] + worker.nftData['roll'] + worker.nftData['firstName'] + worker.nftData['lastName'];

    const TRANSFER_TIME = 0;
    const transferCooldown = await workerContract.methods.getTokenCooldown(sp.tokenId).call({ from: userAddress });
    //console.log(transferCooldown)
    let now = parseInt((Date.now() / 1000).toFixed(0));
    if (transferCooldown > now - TRANSFER_TIME) {
      worker['canTransfer'] = 0;
    } else {
      worker['canTransfer'] = 1;
    }
    worker['transferCooldown'] = (parseInt(transferCooldown) + 0) * 1000;

    const cooldown = 86400;
    const mineTime = parseInt(worker.nftData['lastMine']) + cooldown;
    if (mineTime * 1000 <= currentTime) {
      worker['canMine'] = true;
      worker['mineDate'] = new Date();
    } else {
      worker['canMine'] = false;
      worker['mineDate'] = new Date(mineTime * 1000);
    }

    worker['price'] = web3.utils.fromWei(sp.price, 'ether');
    worker['sellerAddress'] = sp.sellerAddress;

    worker['marketId'] = sp.marketId;
    worker['seller'] = sp.sellerAddress.slice(38, 42);

    const nftInfo = await marketplaceContract.methods.getMarketItem(sp.marketId).call({ from: userAddress });

    if (nftInfo.buyerAddress !== '0x0000000000000000000000000000000000000000') {
      worker['sold'] = 1;
    } else {
      worker['sold'] = 0;
    }

    return worker;
  };

  /** Fetches Workers from the marketplace
   */
  const fetchMiners = useCallback(async () => {
    try {
      fetch(`https://api.cryptomines.app/api/workers`)
        .then((response) => response.json())
        .then((jsonData) => jsonData)
        .then((marketNft) => {
          updateMarketWorkers(
            marketNft.sort((a, b) => web3.utils.fromWei(a.price, 'ether') - web3.utils.fromWei(b.price, 'ether'))
          );
          ARRAY_TO_FILTER.current = marketNft.sort(
            (a, b) => web3.utils.fromWei(a.price, 'ether') - web3.utils.fromWei(b.price, 'ether')
          );
        })
        .catch((error) => {
          // handle your errors here
          console.error(error);
        });

      if (marketplaceContract !== null) {
        const stoneAllowanceMarket = await stoneContract.methods
          .allowance(userAddress, MARKETPLACE_CONTRACT)
          .call({ from: userAddress });

        if (stoneAllowanceMarket < 1) {
          SweetAlert.fire({
            title: 'Approve Marketplace Contract',
            html: 'You need to approve your <b>$ETERNAL</b> token on the <b>Marketplace Contract.</b>',
            icon: 'info',
            confirmButtonText: 'Approve Contract',
            reverseButtons: true,
          }).then(async (result) => {
            await stoneContract.methods
              .approve(MARKETPLACE_CONTRACT, web3.utils.toWei('5000000', 'ether'))
              .send({ from: userAddress });
          });
        }
      }
    } catch (error) {
      console.log('error: ', error);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [marketplaceContract, userAddress]);

  useEffect(() => {
    if (web3 !== null && marketplaceContract !== null) {
      fetchMiners().then(async () => {
        rerenderList();
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [marketplaceContract, web3, userAddress, fetchMiners]);

  useEffect(() => {
    if (marketWorkers?.length) {
      return rerenderList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtering, marketWorkers]);

  const rerenderList = () => {
    if (filtering) {
      updateDisplayDataWorkers(marketWorkers);
      updateDisplayDataWorkers(marketWorkers.slice(0, cardsPerPage));
      setLoading(false);
    } else {
      setLoading(true);
      fetch(`https://api.cryptomines.app/api/workers?cursor=${pageNumber}&limit=${cardsPerPage}`)
        .then((response) => response.json())
        .then((jsonData) => jsonData)
        .then((nftItems) => {
          updateDisplayDataWorkers(
            nftItems.sort((a, b) => web3.utils.fromWei(a.price, 'ether') - web3.utils.fromWei(b.price, 'ether'))
          );
          setLoading(false);
        })
        .catch((error) => {
          // handle your errors here
          console.error(error);
        });
    }
  };

  const changePage = async ({ selected }) => {
    setLoading(true);
    setPageNumber(selected);
    const offset = selected * cardsPerPage;
    if (filtering) {
      updateDisplayDataWorkers(marketWorkers);
      updateDisplayDataWorkers(marketWorkers.slice(offset, offset + cardsPerPage));
      setLoading(false);
    } else {
      fetch(`https://api.cryptomines.app/api/workers?cursor=${offset}&limit=${cardsPerPage}`)
        .then((response) => response.json())
        .then((jsonData) => jsonData)
        .then((d) => {
          updateDisplayDataWorkers(
            d.sort((a, b) => web3.utils.fromWei(a.price, 'ether') - web3.utils.fromWei(b.price, 'ether'))
          );
          setLoading(false);
        })
        .catch((error) => {
          // handle your errors here
          console.error(error);
        });
    }
  };

  const buySpaceship = async (marketId) => {
    window.gtag('event', 'buyNFT', { marketId: marketId, address: userAddress });
    SweetAlert.fire({
      title: 'You want to <b>BUY</b> this NFT? ',
      icon: 'question',
      confirmButtonText: 'Proceed',
      footer:
        '<center><span class="txt-danger">Please double check the amount of ETERNAL. <br>You can\'t recover ETERNAL. <br><b>We neither.</b></span></center>',
    }).then(async () => {
      const buyingShip = await marketplaceContract.methods.buyNFT(marketId).send({ from: userAddress });
      const currentStones = await stoneContract.methods.balanceOf(userAddress).call({ from: userAddress });
      const currentWorkers = await workerContract.methods.balanceOf(userAddress).call({ from: userAddress });
      const currentMinePower = await cryptominesContract.methods.getMinePower().call({ from: userAddress });
      setWorkerAmount(currentWorkers);
      setStoneAmount(web3.utils.fromWei(currentStones, 'ether'));
      setMinePower(currentMinePower);
      //console.log('buyingShip: ', buyingShip);
      await fetchMiners().then(setLoading(false));
      SweetAlert.fire({
        title: 'Nice!',
        text: 'Your NFT was purchased. 😊 ',
        icon: 'success',
      });
    });
  };

  const unlistNFT = async (marketId) => {
    window.gtag('event', 'unlistNFT', { marketId: marketId, address: userAddress });
    await marketplaceContract.methods.unlistNFT(marketId).send({ from: userAddress });
    SweetAlert.fire({
      title: 'Nice!',
      text: 'Your NFT was unlisted. 😊 ',
      icon: 'success',
    });
  };

  const showOnly = displayDataWorkers?.map((card, i) => (
    <SpaceshipCard
      key={card.marketId}
      card={card}
      layoutColumns={layoutColumns}
      videoAnimation={videoAnimation}
      buySpaceship={buySpaceship}
      unlistNFT={unlistNFT}
      userAddress={userAddress}
      getMetadata={getMetadata}
    />
  ));

  return (
    <Fragment>
      <Breadcrumb parent='Marketplace' title='Marketplace' />
      <Container fluid={true}>
        <Row>
          <Col sm='12'>
            <Card className='card-absolute'>
              <CardHeader className='bg-secondary'>
                <h3 className='shop-title'>Marketplace - Workers</h3>
                {/* <button
                  className='toggle-information btn btn-success'
                  onClick={() => setToggleInformation(!toggleInformation)}
                >
                  ?
                </button> */}
              </CardHeader>
              <CardBody>
                <Information section='marketWorkers' display={true} />
                <div style={{ position: 'relative' }}>
                  <Filter
                    stateRef={ARRAY_TO_FILTER.current}
                    marketSpaceships={marketWorkers}
                    updateMarketSpaceships={updateMarketWorkers}
                    setFiltering={setFiltering}
                    wallet={userAddress}
                    web3={web3}
                  />
                </div>
                {loading ? <Loading /> : ''}
                {marketWorkers?.length > cardsPerPage ? (
                  <ReactPaginate
                    previousLabel={'Previous'}
                    nextLabel={'Next'}
                    pageCount={pageCount}
                    onPageChange={changePage}
                    containerClassName={'pagination'}
                    previousLinkClassName={'previousBttn'}
                    nextLinkClassName={'nextBttn'}
                    disabledClassName={'paginationDisabled'}
                    activeClassName={'activeLinkClassName'}
                    pageClassName='page-item'
                  />
                ) : (
                  ''
                )}
                <Row className='gridRow'>{displayDataWorkers?.length > 0 && !loading ? <>{showOnly}</> : ''}</Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

const SpaceshipCard = ({ card, videoAnimation, buySpaceship, unlistNFT, userAddress, layoutColumns, getMetadata }) => {
  const [convert, setConvert] = useState(undefined);
  const [btnTooltip, setBtnTooltip] = useState(false);
  const toggle = () => setBtnTooltip(!btnTooltip);

  useEffect(() => {
    getMetadata(card).then((d) => setConvert(d));
  }, [card, getMetadata]);

  return convert !== undefined ? (
    <div
      className={`${layoutColumns === 3 ? 'col-xl-3 col-sm-6 xl-4 col-grid-box' : 'col-xl-' + layoutColumns}`}
      key={card.tokenId}
    >
      <Card>
        <div className={`product-box ${convert.sold === 0 ? '' : 'disabled'}`}>
          <span className={`ribbon ribbon`}>
            <b>UID: </b> 0x{convert.uid}
            <br />
            <b>Market ID: </b> 0x{convert.marketId}
            <br />
            <b>Seller: </b> 0x...{convert.seller}
            <br />
            <b>Name: </b> {worker_firstName[card.nftData.firstName]} {worker_lastName[card.nftData.lastName]}
            <br />
            <b>Transfer Cooldown: </b>{' '}
            {convert.canTransfer ? 'Available' : 'Available'}
          </span>

          {!convert.canMine && (
            <span className='ribbon ribbon ribbon-vertical-right ribbon-danger'>
              <i className='icon-time'></i>
            </span>
          )}

          <div className={`product-img ${convert.season}_up`}>
            <span className='ribbon ribbon-clip-bottom-right ribbon-primary'>
              <b>Worker Rarity:</b>{' '}
              <Rating
                initialRating={card.nftData.level}
                emptySymbol='fa fa-star-o'
                fullSymbol='fa fa-star'
                readonly={true}
              />{' '}
              <br />
            </span>

            {card.nftData.minePower <= 14 ? (
              <span className='ribbon ribbon-clip-bottom ribbon-success'>
                <b>Legacy Worker 🥉</b>
              </span>
            ) : (
              ''
            )}

            {videoAnimation ? (
              <video
                className='img-fluid'
                muted
                loop={videoAnimation}
                autoPlay={videoAnimation}
                poster={`${ASSETS_CDN}/nft-placeholder.png`}
              >
                {convert.canMine ? (
                  <source
                    src={`${ASSETS_CDN}/${convert.season}/rank${card.nftData.level}/variant${convert.variant}/${
                      Math.floor(Math.random() * 4) + 1
                    }.mp4`}
                    type='video/mp4'
                  />
                ) : (
                  <source
                    src={`${ASSETS_CDN}/${convert.season}/rank${card.nftData.level}/variant${convert.variant}/5.mp4`}
                    type='video/mp4'
                  />
                )}
                <img src={`${ASSETS_CDN}/nft-placeholder.png`} />
              </video>
            ) : (
              <div>
                {convert.canMine ? (
                  <img className='img-fluid'
                    src={`${ASSETS_CDN}/${convert.season}/rank${card.nftData.level}/variant${convert.variant}/1.png`}
                    alt='Cryptomines Workers '
                  />
                ) : (
                  <img className='img-fluid'
                    src={`${ASSETS_CDN}/${convert.season}/rank${card.nftData.level}/variant${convert.variant}/5.png`}
                    alt='Cryptomines Workers '
                  />
                )}
              </div>
            )}
          </div>
          <div className={`product-details ${convert.season}_down`}>
            <div className='product-price'>
              <center className={`${convert.season}_text`}> {card.nftData.minePower} MP </center>
            </div>

            <hr />
            <center>
              <b>Contract Expire: </b>{' '}
              {convert.needContract ? (
                <b className='txt-danger'>Expired 📄</b>
              ) : (
                <Moment date={convert.contractDate} fromNow />
              )}
              <br />
              <b>Can Mine: </b> {convert.canMine && <span>Now</span>}{' '}
              {!convert.canMine && <Moment date={convert.mineDate} fromNow />}
            </center>
            <hr />
            <center>
              {convert.sold === 0 ? (
                <Button className='btn btn-primary' onClick={() => buySpaceship(card.marketId)}>
                  {parseFloat(parseFloat(convert.price).toFixed(3))} ETERNAL <i className='icon-shopping-cart'></i>
                </Button>
              ) : (
                <div className='btn btn-square disabled'>SOLD or UNLISTED</div>
              )}
            </center>

            {card.sellerAddress === userAddress && convert.sold === 0 ? (
              <Button
                id={'unlist-btn' + convert.uid}
                className='btn btn-info unlist-button'
                onClick={() => unlistNFT(card.marketId)}
              >
                <span>UNLIST</span>
                <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 64 64'>
                  <title>Unlist NFT</title>
                  <desc>Remove item from Marketplace</desc>
                  <path
                    data-name='layer2'
                    d='M47 7a16 16 0 1 0 16 16A16 16 0 0 0 47 7zm8 18H39a2 2 0 0 1 0-4h16a2 2 0 0 1 0 4z'
                  ></path>
                  <circle data-name='layer2' cx='21' cy='55' r='4'></circle>
                  <circle data-name='layer2' cx='47' cy='55' r='4'></circle>
                  <path
                    data-name='layer1'
                    d='M47 43a20 20 0 0 1-20-20H16.8L12.9 6.5A2 2 0 0 0 11 5H3a2 2 0 0 0 0 4h6.4l9 38h33l1.6-4.9a20 20 0 0 1-6 .9z'
                  ></path>
                </svg>
                <Tooltip placement='top' isOpen={btnTooltip} target={'unlist-btn' + convert.uid} toggle={toggle}>
                  Unlist my NFT
                </Tooltip>
              </Button>
            ) : (
              ''
            )}
          </div>
        </div>
      </Card>
    </div>
  ) : (
    ''
  );
};

export default MarketplaceSpaceships;
